import React from 'react'

import enhance from './enhance'
import {
  Wrapper,
  Badge,
  BoldText,
  RatingTooltip,
  RatingTooltipContainer,
  CMSTooltipContainer,
  CMSTooltip,
} from './styles'

const QualityScore = ({
  scoreArr,
  qualityScoreTextArr,
  fullRatingsDisplayBool = false,
  CMSTooltipsBool = true,
  reviewCount,
}) => (
  <>
    <Wrapper>
      <RatingTooltipContainer>
        <Badge />
        <BoldText>{scoreArr[0]}</BoldText>
        {`/${scoreArr[1]} `}
        {qualityScoreTextArr[0]}
        {CMSTooltipsBool && (
          <RatingTooltip
            fullRatingsDisplayBool={fullRatingsDisplayBool}
            reviewCount={reviewCount}
          >
            Quality ratings are out of 100 and
            <br />
            have an average score of 90.
          </RatingTooltip>
        )}
      </RatingTooltipContainer>
      <CMSTooltipContainer>
        {qualityScoreTextArr[1]}
        {fullRatingsDisplayBool && (
          <CMSTooltip>
            CMS (The Centers for Medicare &
            <br /> Medicaid Services) administers the
            <br /> nation’s major healthcare programs
            <br /> including Medicare, Medicaid, and
            <br /> CHIP.
          </CMSTooltip>
        )}
      </CMSTooltipContainer>
    </Wrapper>
  </>
)

export default enhance(QualityScore)
